import { Tooltip } from '@svg/antd';
import React from 'react';
import SvgIcon from './svgIcon';
import useStyles from './style'

interface FavoriteProps {
  // 收藏状态
  isFavorited: boolean;
  // 是否显示快捷收藏
  showQuickCollect?: boolean;
  // 快捷收藏提示
  quickTip?: string;
  // 普通收藏点击事件
  onFavoriteClick?: (data: any) => void;
  // 快捷收藏点击事件
  onQuickCollectClick?: (data: any) => void;
  // 取消收藏事件
  onCancelFavorite?: (data: any) => void;
  // 快捷收藏鼠标移入事件
  onQuickCollectMouseEnter?: () => void
  // 数据集合
  data: any;
}
const Favorite = (props: FavoriteProps) => {
  const { isFavorited, showQuickCollect = true, quickTip, onFavoriteClick, onCancelFavorite, onQuickCollectClick, data, onQuickCollectMouseEnter } = props
  const { styles, cx } = useStyles();
  const [favoriteHover, setFavoriteHover] = React.useState(false);
  const [unFavoriteHover, setUnFavoriteHover] = React.useState(false);
  /**
  * @description 普通收藏点击事件
  */
  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    if (isFavorited) {
      onCancelFavorite?.(data);
    } else {
      onFavoriteClick?.(data);
    }
  }
  return (
    <div className={cx(styles, { 'show-quick': !isFavorited })}>

      <SvgIcon
        d="M466.432 94.0544L368.7424 302.5408a53.504 53.504 0 0 1-15.872 19.8144 49.5616 49.5616 0 0 1-22.7328 9.728l-222.2592 33.6384a49.8176 49.8176 0 0 0-25.7024 12.1856c-7.3216 6.5536-16 15.1552-15.7184 24.7808-2.9184 9.6768-3.2256 19.968-0.9216 29.8496 2.304 9.8304 7.168 18.7904 14.08 25.8048l160.4096 164.0448c12.288 12.4928 17.8176 30.72 14.848 48.384l-37.888 225.4848c-1.6896 9.984-0.6656 20.2752 2.9184 29.696 3.584 9.3696 9.5232 17.5104 17.2544 23.5008a48.7424 48.7424 0 0 0 53.9136 4.2496l196.9664-109.7728a48.8448 48.8448 0 0 1 47.616 0l197.2736 109.8752a48.6912 48.6912 0 0 0 53.8624-4.2496c7.68-5.9392 13.7216-14.08 17.2544-23.4496 3.584-9.4208 4.608-19.6608 2.9696-29.6448l-37.6832-225.6896a57.2416 57.2416 0 0 1 1.6896-26.1632 54.784 54.784 0 0 1 13.1072-22.2208l160.256-164.096c6.912-7.0656 11.776-15.9744 14.08-25.8048a57.2416 57.2416 0 0 0-0.9216-29.7984 54.4256 54.4256 0 0 0-15.7184-24.7296 49.8176 49.8176 0 0 0-25.6-12.2368l-220.7744-33.5872a49.5616 49.5616 0 0 1-22.5792-9.728c-6.7072-5.0688-12.1344-11.776-15.872-19.6096l-99.1744-209.0496a53.0944 53.0944 0 0 0-18.944-21.76 48.9984 48.9984 0 0 0-53.6576 0.1536 53.1968 53.1968 0 0 0-18.7904 21.8624z"
        width="16"
        height="16"
        color={isFavorited ? '#FFAA00' : unFavoriteHover ? '#5B5E60' : '#959598'}
        onClick={onClick}
        onMouseEnter={() => setUnFavoriteHover(true)}
        onMouseLeave={() => setUnFavoriteHover(false)}
      />
      {showQuickCollect && (<div className='quick-box'>
        {/* 分隔线 */}
        <div className='divider'></div>
        <div className='quick-btn'>
          <Tooltip placement="bottom" title={quickTip} zIndex={1100}>
            <SvgIcon
              style={{ marginLeft: '3.5px' }}
              d="M533.08802845 959.217664l329.42762666-494.17056711a42.23431111 42.23431111 0 0 0-35.127296-65.71076267h-259.05652622v-311.07754667a42.23431111 42.23431111 0 0 0-77.41986134-23.47645155l-329.42762666 494.17056711a42.29256533 42.29256533 0 0 0 35.127296 65.71076267h259.05652622v311.07754667a42.23431111 42.23431111 0 0 0 77.41986134 23.47645155z"
              width="16"
              height="16"
              color={favoriteHover ? '#5B5E60' : '#959598'}
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                onQuickCollectClick?.(data)
              }}
              onMouseEnter={() => {
                onQuickCollectMouseEnter?.()
                setFavoriteHover(true)
              }}
              onMouseLeave={() => setFavoriteHover(false)}
            />
          </Tooltip>
        </div>
      </div>
      )}

    </div>
  );
};

export default Favorite;
